module.exports = __webpack_public_path__ + "img/review-2.361fc2f0.png";